import { CryptolectApiClient } from "@cryptolect/api-client";

const baseUrl =
  (import.meta.env.VITE_API_URL as string | undefined) ??
  "https://cryptolect-api-dev.benjamin-t-durham.workers.dev";

// Cookie-based session: the web app shares the same Better Auth session as
// `/v1/auth`, so every request must forward credentials. The SDK already
// defaults to `"include"`, but we declare it explicitly here so a future
// reader doesn't need to dig into the SDK to verify the auth posture.
export const apiClient = new CryptolectApiClient({
  baseUrl,
  credentials: "include",
});
